import { Avatar, AvatarFallback } from "@/core/components/ui/avatar";
import { Stack } from "@/core/components/ui/stack";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/core/components/ui/tooltip";
import { Typography } from "@/core/components/ui/typography";
import { formatDateTimeWithZone, formatRelativeTime } from "@/core/utils/date";
import { cn } from "@/core/utils/utils";

interface MessageDisplayProps {
  message: string;
  mediaUrls: string[];
  isOutbound: boolean;
  createdAt: string;
  showTime?: boolean;
}

export const MessageDisplay = ({
  message,
  isOutbound,
  mediaUrls,
  createdAt,
  showTime,
}: MessageDisplayProps) => (
  <Stack
    className={cn("max-w-[330px] self-start", {
      "self-end": isOutbound,
      "pb-4": showTime,
    })}
    gap="sm"
  >
    <Stack
      className={cn("rounded-lg bg-surface-secondary p-3", {
        "self-end bg-green-10": isOutbound,
      })}
    >
      {message && <Typography>{message}</Typography>}
      {mediaUrls.map((mediaUrl, index) => (
        <img
          src={mediaUrl}
          alt={`Message attachment ${index + 1}`}
          className="max-h-[200px] w-[200px] object-contain"
        />
      ))}
    </Stack>
    {showTime && (
      <Stack
        direction="row"
        align="center"
        gap="sm"
        className={cn({ "self-end": isOutbound })}
      >
        <Tooltip>
          <TooltipTrigger>
            <Typography variant="captionW1" className="text-text-secondary">
              {formatRelativeTime(createdAt)}
            </Typography>
          </TooltipTrigger>
          <TooltipContent>{formatDateTimeWithZone(createdAt)}</TooltipContent>
        </Tooltip>
        {isOutbound && (
          <Tooltip>
            <TooltipTrigger>
              <Avatar className="h-[22px] w-[22px] border-2 border-stroke-tabSelected">
                <AvatarFallback className="border-none bg-transparent p-0 text-[13px] font-medium text-tab-selected-text">
                  v
                </AvatarFallback>
              </Avatar>
            </TooltipTrigger>
            <TooltipContent>
              This orange circle signifies an automated Volca text sent from
              your business phone number to this customer.
              <br />
              <br />
              Soon you'll be able to send back your own messages as needed, and
              we will mark those differently for you
            </TooltipContent>
          </Tooltip>
        )}
      </Stack>
    )}
  </Stack>
);
